export const getTotalMeasuredHoursYear1 = (value) => {
  return {
    type: "GET_TOTAL_MEASURED_HOURS_YEAR_1",
    payload: value,
  };
};
export const getTotalMeasuredHoursYear2 = (value) => {
  return {
    type: "GET_TOTAL_MEASURED_HOURS_YEAR_2",
    payload: value,
  };
};
export const getTotalMeasuredHoursYear3 = (value) => {
  return {
    type: "GET_TOTAL_MEASURED_HOURS_YEAR_3",
    payload: value,
  };
};
